<script setup>
import { useIdleStore } from '~/stores/idle'
const idle = useIdleStore()
const router = useRouter()

function stay() {
  idle.close()
  // tell plugin “user confirmed”
  window.dispatchEvent(new Event('idle:stay'))
}

async function logout() {
  idle.close()
  await router.push('/auth/logout')
}
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>

  <IdleTimeoutDialog @stay="stay" @logout="logout" />
</template>
